/**
 * 依顯示文字產生同意項 key；若無法 slug 則 fallback 為 consent_N
 */
export function slugifyConsentKey(
    label,
    index,
    usedKeys,
    fallbackPrefix = 'consent'
) {
    const ascii = String(label || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 40);
    const base = ascii || `${fallbackPrefix}_${index + 1}`;
    let key = base;
    let suffix = 1;
    while (usedKeys.has(key)) {
        key = `${base}_${suffix}`;
        suffix += 1;
    }
    return key;
}

export function buildConsentItemsPayload(items, fallbackPrefix = 'consent') {
    const usedKeys = new Set();
    return (items || [])
        .filter((item) => item?.label?.trim())
        .map((item, index) => {
            let key = item.key?.trim();
            if (!key || usedKeys.has(key)) {
                key = slugifyConsentKey(
                    item.label,
                    index,
                    usedKeys,
                    fallbackPrefix
                );
            }
            usedKeys.add(key);
            return {
                key,
                label: item.label.trim(),
                content: (item.content || '').trim(),
                required: item.required !== false
            };
        });
}
